var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgThorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.707 22.293L21.3 19.886C21.737 19.193 22 18.378 22 17.5C22 15.019 19.981 13 17.5 13C15.019 13 13 15.019 13 17.5C13 19.981 15.019 22 17.5 22C18.379 22 19.193 21.737 19.886 21.3L22.293 23.707L23.707 22.293ZM15 17.5C15 16.121 16.121 15 17.5 15C18.879 15 20 16.121 20 17.5C20 18.879 18.879 20 17.5 20C16.121 20 15 18.879 15 17.5Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8V22C2 22.553 2.447 23 3 23H14.052C12.222 21.849 11 19.817 11 17.5C11 13.916 13.916 11 17.5 11C19.246 11 20.831 11.696 22 12.821V8H2Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 1H1C0.447 1 0 1.447 0 2V5C0 5.553 0.447 6 1 6H23C23.553 6 24 5.553 24 5V2C24 1.447 23.553 1 23 1Z",
    fill: "#333333"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThorIcon);
export default __webpack_public_path__ + "static/media/ThorIcon.99adb0bc515f5b6707c1065c14d135c7.svg";
export { ForwardRef as ReactComponent };